import React, { useState } from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component';
import { Container, Row, Col, Card, CardImg } from 'reactstrap';
import { useParams } from 'react-router-dom';
import './YDCDetailPage.scss';

import FixedTitleMultipleSelect from '../../widgets/FixedTitleMultipleSelect/FixedTitleMultipleSelect';
import Tabs from '../../widgets/Tabs/Tabs';
import PageTitle from '../../widgets/PageTitle/PageTitle';
import YDCInformation from './Information/YDCInformation';
import YDCCollection from './Collection/YDCCollection';
import YDCFinalist from './Finalist/YDCFinalist';
import YDCJudges from './Judges/YDCJudges';
import YDCAcknowledgement from './Acknowledgement/YDCAcknowledgement';
import YDCAwardsPrizes from './AwardsPrizes/YDCAwardsPrizes';
import YDCAdditional from './Additional/YDCAdditional';
import {
  usePage,
  useTealium,
  useAdGlare,
  useUnmountResetPage,
  useNotFound,
  useDebounceLoading,
  useDelayJsLoadiing,
  useURLChangeCallback,
} from '../../utils/hookHelper';
import UnderConstruction from '../../components/UnderConstruction';
import NoMatch from '../NoMatch';
import HelmetMeta from '../../components/HelmetMeta';
import HelmetTitle from '../../components/HelmetTitle';
import HelmetStyle from '../../components/HelmetStyle';
import HelmetScript from '../../components/HelmetScript';
import HelmetHead from '../../components/HelmetHead';
import config from '../../config';
import Loader from '../../components/Loader';
import { forceToArray } from '../../utils/Helper';

const YDCDetail = (props) => {
  const { i18n, detailData, allowCookies, enableTealium, enableAdGlare, siteConfig } = props;

  const debouncePageLoading = useDebounceLoading(detailData);
  const jsLoading = useDelayJsLoadiing(detailData);
  const notFound = useNotFound(detailData);

  const { id } = useParams();
  usePage(null, config.pageType.YDCDetailPage, `AND (year:${id}) AND (displayStatus:true)`);
  useAdGlare(i18n.locale, siteConfig, detailData, enableAdGlare.status);
  useUnmountResetPage();

  const siteConfigData = siteConfig.data || {};
  const { defaultLanguage } = siteConfigData;

  const { translations = {}, locale = defaultLanguage } = i18n || {};
  // const t = translations[locale] || {};

  const { data = [] } = detailData || {};
  const content = Array.isArray(data) && data.length > 0 ? data[0] : {};
  const dataContent = content[locale] || {};
  const { under_construction = false } = content;

  // HelmetMeta
  const { topMetadata = {} } = content || {};
  const publishDate = topMetadata['TeamSite/LiveSite/PublishDate'];
  const seo = dataContent.seo || {};
  const { css_style_block = '', js_script_block = '', extra_head = '' } = content;

  const title = seo.seo_title;
  const [domTitle, setDomTitle] = useState('');
  const [isScriptReady, setIsScriptReady] = useState(false);

  useTealium(
    i18n.locale,
    siteConfig,
    detailData,
    allowCookies.status,
    enableTealium.status,
    domTitle,
  );

  useURLChangeCallback(locale, content, null, [], isScriptReady);

  const helmetTitleCallBack = (newState) => {
    setDomTitle(newState.title);
  };

  const helmetScriptCallBack = (isReady) => {
    setIsScriptReady(isReady);
  };

  const curLang = i18n.locale;
  // const content = detailData?.data?.[0] || {};
  // const dataContent = content[curLang] || {};

  //data
  const { basic } = content;
  const collectionPhotos = forceToArray(content.collection);
  const finalist = forceToArray(content.finalist);
  const judgesList = forceToArray(content.judges);
  const acknowledgementList = forceToArray(content.acknowledgement);
  const collectionDescriptions = forceToArray(dataContent.collection_detail);
  const {
    awards_prizes: awardsPrizes,
    information,
    detail,
    finalist_detail,
    acknowledgement_detail,
    judges_detail,
    apply_button: applyButton,
  } = dataContent;
  console.log({ applyButton });
  const {
    apply_display_status = false,
    apply_end,
    apply_url = '',
    apply_start,
  } = applyButton || {};

  const isShowApplyButton = () => {
    const now = new Date().getTime();
    const startTime = apply_start ? new Date(apply_start).getTime() : null;
    const endTime = apply_end ? new Date(apply_end).getTime() : null;
    console.log({ now, startTime, endTime });
    if (apply_display_status) {
      if (startTime && endTime) {
        return now >= startTime && now <= endTime;
      } else if (startTime && !endTime) {
        return now >= startTime;
      } else if (!startTime && endTime) {
        return now <= endTime;
      } else {
        return true;
      }
    }
    return false;
  };

  const additionalItemDetails = forceToArray(dataContent.additional_item_detail);

  const [activeTab, setActiveTab] = useState(0);

  const toggleTab = (selectIndex) => {
    setActiveTab(selectIndex);
  };

  const localeSource = {
    en: {
      information: 'INFORMATION',
      collection: 'COLLECTION',
      finalist: 'FINALIST',
      judges: 'JUDGES',
      acknowledgement: 'ACKNOWLEDGEMENT',
      awardsAndPrizes: 'AWARDS & PRIZES',
    },
    tc: {
      information: '資訊',
      collection: 'COLLECTION',
      finalist: '入圍名單',
      judges: '評判',
      acknowledgement: '鳴謝',
      awardsAndPrizes: '獎項及獎品',
    },
    sc: {
      information: '资讯',
      collection: 'COLLECTION',
      finalist: '入圍名單',
      judges: '評判',
      acknowledgement: '鸣谢',
      awardsAndPrizes: '奖项及奖品',
    },
  };

  const pages = [
    (information?.information_description ||
      detail?.date ||
      detail?.time ||
      detail?.venue ||
      information?.key_dates_description ||
      information?.lucky_draw_result_description) && {
      id: '1',
      label: localeSource[curLang ? curLang : 'en'].information,
      content: (
        <YDCInformation
          curLang={curLang}
          detail={detail}
          information={information}
          title={localeSource[curLang ? curLang : 'en'].information}
        />
      ),
    },
    (collectionPhotos?.[0]?.collection_images_upload ||
      collectionPhotos?.[0]?.collection_video ||
      collectionDescriptions?.[0]?.collection_name) && {
      id: '2',
      label: localeSource[curLang ? curLang : 'en'].collection,
      content: (
        <YDCCollection
          curLang={curLang}
          collectionPhotos={collectionPhotos}
          collectionDescriptions={collectionDescriptions}
          title={localeSource[curLang ? curLang : 'en'].collection}
        />
      ),
    },
    finalist?.[0]?.finalist_images_upload && {
      id: '3',
      label: localeSource[curLang ? curLang : 'en'].finalist,
      content: (
        <YDCFinalist
          curLang={curLang}
          finalist={finalist}
          title={localeSource[curLang ? curLang : 'en'].finalist}
          finalist_detail={forceToArray(finalist_detail)}
        />
      ),
    },
    judgesList?.[0]?.judges_images_upload && {
      id: '4',
      label: localeSource[curLang ? curLang : 'en'].judges,
      content: (
        <YDCJudges
          curLang={curLang}
          judgesList={judgesList}
          judges_detail={forceToArray(judges_detail)}
          title={localeSource[curLang ? curLang : 'en'].judges}
        />
      ),
    },
    acknowledgementList?.[0]?.acknowledgement_images_upload && {
      id: '5',
      label: localeSource[curLang ? curLang : 'en'].acknowledgement,
      content: (
        <YDCAcknowledgement
          curLang={curLang}
          acknowledgementList={acknowledgementList}
          acknowledgement_detail={forceToArray(acknowledgement_detail)}
          title={localeSource[curLang ? curLang : 'en'].acknowledgement}
        />
      ),
    },
    awardsPrizes?.awards_prizes_description && {
      id: '6',
      label: localeSource[curLang ? curLang : 'en'].awardsAndPrizes,
      content: (
        <YDCAwardsPrizes
          curLang={curLang}
          awardsPrizes={awardsPrizes}
          title={localeSource[curLang ? curLang : 'en'].awardsAndPrizes}
        />
      ),
    },
    ...(additionalItemDetails?.map(
      (item, index) =>
        item.additional_item_title &&
        item.additional_item_body && {
          id: 7 + index,
          label: item.additional_item_title,
          content: <YDCAdditional curLang={curLang} data={item} tabId={7 + index} />,
        },
    ) || []),
  ].filter(Boolean);

  const mainContent = (
    <div className="ydcDetail-page">
      <Container>
        <Row>
          <Col xs={8} sm={8} md={6} lg={6} xl={6} xxl={6}>
            <PageTitle title={`YDC ${props.match.params.id}`} isFirst />
          </Col>
          {isShowApplyButton() && (
            <Col xs={4} sm={4} md={6} lg={6} xl={6} xxl={6} className="btn-col">
              <a target="_blank" rel="noopener noreferrer" href={apply_url} className="apply-btn">
                {
                  {
                    sc: '立即申请',
                    en: 'APPLY NOW',
                    tc: '立即申請',
                  }[curLang]
                }
              </a>
            </Col>
          )}
        </Row>
        <Row>
          <Col>
            {basic?.headBanner_upload && (
              <img src={basic.headBanner_upload} style={{ width: '100%', height: '100%' }} />
            )}
          </Col>
        </Row>
        <div style={{ paddingTop: '30px' }}>
          <Tabs pages={pages} activeTab={activeTab} toggleTab={toggleTab} showAll />
        </div>
      </Container>
    </div>
  );

  const pageEle = notFound ? (
    <NoMatch />
  ) : (
    <>
      {under_construction && <UnderConstruction />}
      <h1 className="access-elem">{seo.seo_title}</h1>
      {!under_construction && mainContent}
      {!under_construction && (
        <HelmetScript
          helmetScriptCallBack={helmetScriptCallBack}
          extraHead={extra_head}
          jsScript={js_script_block}
        />
      )}
    </>
  );

  return (
    <>
      {debouncePageLoading || jsLoading ? <Loader /> : pageEle}
      {!debouncePageLoading && <HelmetHead extraHead={extra_head} />}
      {!debouncePageLoading && <HelmetStyle stylesheet={css_style_block} />}
      {!debouncePageLoading && <HelmetTitle title={title} cb={helmetTitleCallBack} />}
      {!debouncePageLoading && <HelmetMeta seo={seo} publishDate={publishDate} />}
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  detailData: state.generalPage,
  allowCookies: state.allowCookies,
  enableTealium: state.enableTealium,
  enableAdGlare: state.enableAdGlare,
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(YDCDetail);

export { YDCDetail as YDCDetailComponent }; // <- For component Unit Test
export default connectStore;
